<template>
    <div>
        <!-- <div class="ole" style="height: 0px;">
            <div></div>
        </div> -->
        <br>
        <div id="home" class="page-alternate">
            <div class="container" align="center">
                <!-- Title Page -->
                <p class="credits" style="padding-bottom: 20px;" align="center">
                    <img :src="skin.header_desktop.logo" width="30%">
                    <br><br>
                </p>
                <!-- End Title Page -->
                <h3 style="color:white; font-weight: normal; padding-bottom: 10px;">
                    Ingrese sus credenciales para acceder a <span class="color-text">OdinPlay</span> - Club Privado
                </h3>
                <form @submit.prevent="login">
                    <input type="hidden" name="submitted" id="submitted" value="1">
                    <p align="center">
                        <input v-model="username" type="text" name="username" id="username" maxlength="50" placeholder="Usuario" class="Usuario input-login">
                        <br>
                        <input v-model="password" type="password" name="password" id="password" maxlength="50" placeholder="Clave" class="Clave input-login">
                        <br>
                        <button type="submit" class="button button-small login-btn">INGRESAR</button>
                        <div v-if="status.message != ''" :class="'alert alert-' + status.type" role="alert">{{ status.message }}</div>
                    </p>
                </form>
            </div>
        </div>
        <p align="center"><a href="#" target="_blank">Administracion de Gerentes .</a></p>
    </div>

</template>
<script>
import axios from 'axios';
export default {
    name: "login",
    props: ['skin', 'translation', 'language'],
    data() {
        return {
            username: "",
            password: "",
            resetPassword: false,
            status: {
                message: "",
                type: ""
            },
            login_inProcess: false
        }
    },
    computed: {
    },
    methods: {
        async login() {
            this.login_inProcess = true;
            if (this.resetPassword) {
                if (this.username != "") {
                    let reset = await axios.post(this.$store.getters["getDomain"] + "/swarm/remote/forgot_password", {
                        "email": this.username
                    })
                    if (reset.data.success) {
                        this.status.message = reset.data.message;
                        this.status.type = "success";
                    }
                    else {
                        this.status.message = reset.data.message;
                        this.status.type = "danger";
                    }
                    this.resetPassword = false;
                }
                else {
                    this.status.message = this.translate("input_email");
                    this.status.type = "danger";
                }
                this.login_inProcess = false;
            }
            else {
                let data = await this.$store.dispatch('login', { username: this.username, password: this.password });
                if (data == "success") {
                    // document.getElementById('closeLogin').click();
                    this.$root.$emit('forceRender');
                    this.login_inProcess = false;
                    this.username = '';
                    this.password = '';
                    this.status.message = '';
                }
                else {
                    this.status.message = data;
                    this.status.type = "danger";
                    this.login_inProcess = false;
                }
            }

        },
        reset_password() {
            this.resetPassword = true;
            this.login();
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        },
    }
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Exo+2:wght@300&display=swap');

.ole {
    background-color: transparent; /* Fondo transparente */
}

.page-alternate {
    background-color: transparent; /* Fondo transparente */
    color: #fff;
    padding: 20px;
    border-radius: 10px;
}

.page-alternate {
    background: url(https://resources.jbets.online/odin/fondo1.png) no-repeat fixed;
    background-size: cover;
    padding: 50px 0;
    /* margin-top: 30px; */
    position: relative;
    z-index: 99;
}

.credits img {
    max-width: 100%;
    height: 100%;
}

h3 {
    font-family: "Exo 2", sans-serif;
    color: white;
    font-weight: normal;
    font-size: 25px;
    padding-bottom: 10px;
}

.color-text {
    color: #00b7ff;
}

.input-login {
    background-color: #020f1d;
    font-family: "Exo 2", sans-serif;
    border: none;
    color: #fff;
    font-size: medium;
    border-radius: 5px;
    padding: 5px 10px;
    line-height: .75em;
    margin-bottom: 10px;
    width: 60%; /* Ajusta el ancho de los inputs */
    max-width: 250px; /* Ancho máximo para evitar inputs muy anchos */
    max-height: 30px; /* Ancho máximo para evitar inputs muy anchos */
}

.login-btn {
    font-family: "Exo 2", sans-serif;
    color: #008bb7;
    font-size: normal;
    font-weight: small;
    background-color: #3C3F45;
    border: none;
    padding: 10px 20px;
    border-radius: none;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;
}

.login-btn:hover {
    background-color: #008bb7;
}
</style>
